import { usePermissions } from './usePermissions'

export function usePortPermissions() {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions()
  
  // Specific Port permission checks
  const canCreatePorts = () => hasAnyPermission(['Supplier.TenantInfo.ManagePorts'])
  const canEditPorts = () => hasAnyPermission(['Supplier.TenantInfo.ManagePorts'])
  const canDeletePorts = () => hasAnyPermission(['Supplier.TenantInfo.RemovePorts'])
  const canAssignPortToTenant = () => hasAnyPermission(['Supplier.TenantInfo.ManagePorts'])
  
  // Combined permission checks
  const canAccessPorts = () => hasAnyPermission([
    'Supplier.TenantInfo.ManagePorts',
    'Supplier.TenantInfo.RemovePorts'
  ])
  
  const canManagePorts = () => hasAnyPermission([
    'Supplier.TenantInfo.ManagePorts',
    'Supplier.TenantInfo.RemovePorts'
  ])

  return {
    // Individual permission checks
    canCreatePorts,
    canEditPorts,
    canDeletePorts,
    canAssignPortToTenant,
    
    // Combined permission checks
    canAccessPorts,
    canManagePorts,
    
    // Direct access to permission checker
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  }
} 